import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path:'/join',
    name:'join',
    component:()=>import('../views/join.vue')
  },
  {
    path:'/serve',
    name:'serve',
    component:()=>import('../views/serve.vue')
  },
  {
    path:'/joinRuitu',
    name:'joinRuitu',
    component:()=>import('../views/joinRuitu.vue')
  },
  {
    path:"/joinUs",
    name:"joinUs",
    component:()=>import('../views/joinUs.vue')
  },
  {
    path:"/contact",
    name:"contact",
    component:()=>import('../views/contact.vue')
  },
  {
    path: '/placeOrder',
    name: 'placeOrder',
    component:() => import('../views/placeOrder.vue')
  },
  {
    path: '/feedback',
    name: 'feedback',
    component:() => import('../views/feedback.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
